<template>
  <div>
    <table style="position: absolute;" width="100%" :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8">
      <tr max-height="48px" height="48px">

        <ContenidoBase :titulo="'Reporte de Análisis Comparativo de Gastos'"
          :descripcion="'Imprime el Análisis Comparativo de Gastos de la Empresa'" :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save" @MethodEliminar="remove"
          @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>


      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn small color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                      <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn>
                    <v-btn small dark color="deep-purple accent-2" @click.prevent="notifi('Seguro que desea nuevo', 'n')">
                      <i style="font-size: 25px;" class="fa fa-print"> </i>
                      Listado</v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesComparativoGastos'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
              </template>
            </v-tooltip>

          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">


            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar flat color="#BDBDBD" dense style="border: 1px solid #000000;">


                  <v-avatar tile size="45">
                    <img src="@/assets/iconos_micromarket/custom-reports.png" alt="Reporte">
                  </v-avatar>


                  <span class="font-weight-light" style="font-size: 20px;"> Reporte de Análisis Comparativo de Gastos
                  </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">

                        <!-- -----------------------------  Mes actual  @blur="SelctCbClient"  @focus="cargarCliente"-->
                        <v-combobox v-if="false" autocomplete="off" dense outlined label="Mes Actual *:" :items="RMes"
                          item-text="descripcion" v-model="ComparativoGastos.Mesactual" @blur="SelctCbMesactua">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar-o"></i>
                          </template>
                        </v-combobox>

                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                          <span :class="`d-flex justify-center`"><b>Período actual</b></span>
                        </v-col>
                        <v-row>
                          <v-col cols="12" md="6" sm="6">

                            <v-text-field dense outlined type="date" label="Desde:" :rules="[$rules.required]"
                              v-model="ComparativoGastos.desdeactual" @blur="BlurDesdeactual">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                              </template>

                            </v-text-field>

                          </v-col>

                          <v-col cols="12" md="6" sm="6">
                            <v-text-field dense outlined type="date" label="hasta:" :rules="[$rules.required]"
                              v-model="ComparativoGastos.hastaactual" @blur="BlurHastaactual">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                              </template>

                            </v-text-field>
                          </v-col>
                        </v-row>


                        <!--------------------------------------------------Tipo de gasto --->
                        <v-combobox v-model="ComparativoGastos.tipogasto" label="Categoria gastos:" required outlined
                          dense :rules="[$rules.required]" autocomplete="off" :items="RTipoGasto" item-text="descripcion"
                          @focus="CargarRTipopago" @blur="SelctCbTipoGasto">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-tag"></i>
                          </template>
                        </v-combobox>

                      </v-col>
                      <!-- fn columna 1 -->


                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6" class="pa-0 ma-0 py-0 my-0">

                        <v-combobox v-if="false" autocomplete="off" dense outlined label="Mes Anterior *:" :items="RMes"
                          item-text="descripcion" v-model="ComparativoGastos.Mesanterior" @blur="SelctCbMesanterior">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-calendar-o"></i>
                          </template>
                        </v-combobox>



                        <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                          <span :class="`d-flex justify-center`"><b>Período anterior</b></span>
                        </v-col>
                        <v-row>
                          <v-col cols="12" md="6" sm="6">
                            <v-text-field dense outlined type="date" label="Desde:" :rules="[$rules.required]"
                              v-model="ComparativoGastos.desdeanterior" @blur="BlurDesdeanterior">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                              </template>

                            </v-text-field>
                          </v-col>

                          <v-col cols="12" md="6" sm="6">
                            <v-text-field dense outlined type="date" label="Desde:" :rules="[$rules.required]"
                              v-model="ComparativoGastos.hastaanterior" @blur="BlurHastaanterior">
                              <template v-slot:prepend>
                                <i style="font-size: 20px;" class="fa fa-calendar"></i>
                              </template>

                            </v-text-field>
                          </v-col>
                        </v-row>




                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>
                <ModalReporteFiltros @DataReporteBasico="DDataReporteBasico" :Datos="ComparativoGastos" />


              </v-card>
            </v-container>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', 'width': '325px' }">

            <!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent max-width="100%" max-height="100%"
      transition="fab-transition">
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true" :timeout="120000"
      top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros
  },
  created() {
    var json = {
      titulo: "Reporte de Análisis Comparativo de Gastos",
      descripcion: "Imprime el Análisis Comparativo de Gastos de la Empresa",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,

      accion: [
        "ReportesComparativoGastosNew",
        "ReportesComparativoGastosSave",
        "ReportesComparativoGastosRemove",
        "ReportesComparativoGastosAnular",
        "ReportesComparativoGastosPrintList"
      ],
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("ReportesComparativoGastosNew", this.new);
    // EventBus.$on("ReportesComparativoGastosSave", this.save);
    // EventBus.$on("ReportesComparativoGastosRemove", this.remove);
    // EventBus.$on("ReportesComparativoGastosAnular", this.remove);
    // EventBus.$on("ReportesComparativoGastosPrintList", this.imprimirList);
    EventBus.$on("emitReportesComparativoGastos", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data: () => ({

    RMes: [
      { codigo: 1, descripcion: 'ENERO' },
      { codigo: 2, descripcion: 'FEBRERO' },
      { codigo: 3, descripcion: 'MARZO' },
      { codigo: 4, descripcion: 'ABRIL' },
      { codigo: 5, descripcion: 'MAYO' },
      { codigo: 6, descripcion: 'JUNIO' },
      { codigo: 7, descripcion: 'JULIO' },
      { codigo: 8, descripcion: 'AGOSTO' },
      { codigo: 9, descripcion: 'SEPTIEMBRE' },
      { codigo: 10, descripcion: 'OCTUBRE' },
      { codigo: 11, descripcion: 'NOVIEMBRE' },
      { codigo: 12, descripcion: 'DICIEMBRE' },
    ],
    RTipoGasto: [],
    windowSize: { width: "auto", height: "auto" },
    ComparativoGastos: {

      nombre: 'REPORTE DE ANÁLISIS COMPARATIVO DE GASTOS',
      UrlImprimir: '/reportesgas/ImprimirAnalisisComparativo',
      UrlExel: '/reportesgas/ExcelAnalisisComparativo',
      UrlCorreo: '/reportesgas/CorreoAnalisisComparativo',
      Mesactual: { codigo: 1, descripcion: 'ENERO' },
      Mesanterior: { codigo: 1, descripcion: 'ENERO' },
      tipogasto: null,
      desdeactual: fechaNueva(),
      hastaactual: fechaNueva(),
      desdeanterior: fechaNueva(),
      hastaanterior: fechaNueva()
      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },


    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipo Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    slotHtabla: [
      { text: "Código", value: "codigo" },
      { text: "Descripcion", value: "descripcion" }
    ],

    list: [],
    search: "",
    acti_tb_data: false,

    aalert: {
      estado: false,
      color: null
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
    onResize(e) {
      this.windowSize = e
    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },

    datostabla(e) {
      this.ComparativoGastos = e;
      this.acti_tb_data = false
    },
    save() {

    },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() { },
    DDataReporteBasico() { },
    newwnuevo() {
      (this.ComparativoGastos = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


    CargarRTipopago() {
      this.$axios.get(this.$hostname + this.$hName + '/categoriagastos/findallactivo',
        { headers: this.$store.getters.GetheadersAxios }
      ).then(res => {
        this.RTipoGasto = res.data;
      });
    },

    SelctCbTipoGasto() {

      if (this.ComparativoGastos.tipogasto == null) {
        this.ComparativoGastos.tipogasto = "";
      }

      if (this.ComparativoGastos.tipogasto.codigo == undefined) {
        // this.alerta("Seleccione un tipo gasto", "error");
        this.ComparativoGastos.tipogasto = "";
        return;
      }

    },


    SelctCbMesactua() {
      if (this.ComparativoGastos.Mesactual == null) {
        this.ComparativoGastos.Mesactual = this.RMes[0];
      }

      if (this.ComparativoGastos.Mesactual.codigo == undefined) {
        // this.alerta("Seleccione un tipo gasto", "error");
        this.ComparativoGastos.Mesactual = this.RMes[0];
        return;
      }

    },

    SelctCbMesanterior() {

      if (this.ComparativoGastos.Mesanterior == null) {
        this.ComparativoGastos.Mesanterior = this.RMes[0];
      }

      if (this.ComparativoGastos.Mesanterior.codigo == undefined) {
        // this.alerta("Seleccione un tipo gasto", "error");
        this.ComparativoGastos.Mesanterior = this.RMes[0];
        return;
      }

    },



    BlurDesdeactual() {
      if (this.ComparativoGastos.desdeactual.toString().length == 0) {
        this.ComparativoGastos.desdeactual = this.fechaNueva()
      }
    },


    BlurHastaactual() {
      if (this.ComparativoGastos.hastaactual.toString().length == 0) {
        this.ComparativoGastos.hastaactual = this.fechaNueva()
      }
    },

    BlurDesdeanterior() {
      if (this.ComparativoGastos.desdeanterior.toString().length == 0) {
        this.ComparativoGastos.desdeanterior = this.fechaNueva()
      }
    },


    BlurHastaanterior() {
      if (this.ComparativoGastos.hastaanterior.toString().length == 0) {
        this.ComparativoGastos.hastaanterior = this.fechaNueva()
      }
    },



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() { }
  }
};
</script>

<style></style>
